import useNotificationsCustom from './useNotificationsCustom';

export default useNotificationsCustom;
